// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CourseController from "./course_controller.js"
application.register("course", CourseController)

import PersonCourseController from "./person_course_controller.js"
application.register("person_course", PersonCourseController)

import OifWarningController from "./oif_warning_controller.js"
application.register("oif-warning", OifWarningController)

import SearchSubjectController from "./search_subject_controller.js"
application.register("search-subject", SearchSubjectController)
